<template>
  <div :class="['tva-chapter', `tva-chapter-${chapterIndex}`]" ref="chapter">
    <Header :expanded="true" :chapter="chapterIndex"/>
    <Scroller
      :threshold=".5"
      :top=".2"
      :bottom=".9"
      v-on:index="index = $event.value"
      v-on:progress="progress = $event.value"
      v-on:offset="offset = $event.value"
      v-on:activeSections="activeSections = $event.value"
      v-on:direction="direction = $event.value"
    >
      <div ref="foreground">
        <section
          v-for="(section, sectionIndex) in $ml.get('chapters')[chapterIndex].content"
          :key="'section-'+sectionIndex"
        >
          <ChapterIntro v-if="section.type === 'intro'" :content="section.content"/>
          <Paragraph v-if="section.type === 'paragraph'" :content="section.content"/>
          <Highlight v-if="section.type === 'highlight'" :content="section.content"/>
          <Quote v-if="section.type === 'quote'" :content="section.content"/>
          <NumberImage
            v-if="section.type === 'number-image'"
            :content="section.content"
            :active="isIncluded(activeSections, sectionIndex)"
          />
          <VideoPreview v-if="section.type === 'video-preview'" :content="section.content"/>
          <VideoOverlay v-if="section.type === 'video-overlay'" :content="section.content"/>
          <SliderImages v-if="section.type === 'slider-images'" :content="section.content"/>
          <BigNumber v-if="section.type === 'big-number'" :content="section.content"/>
          <PointedList v-if="section.type === 'pointed-list'" :content="section.content"/>
          <Download v-if="section.type === 'download'" :content="section.content"/>
          <VizParagraph v-if="section.type === 'viz-paragraph'" :content="section.content"/>
          <VizRuota v-if="section.type === 'viz-ruota'" :content="section.content"/>
          <VizMosaico v-if="section.type === 'viz-mosaico'" :content="section.content"/>
          <InteractiveMap v-if="section.type ==='intractive_map'" :content="section.content"/>
          <VizTimeline v-if="section.type ==='viz-timeline'" :content="section.content"/>
        </section>
      </div>
    </Scroller>
    <Footer/>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import Scroller from "../utilities/Scroller.vue";
import ChapterIntro from "../components/ChapterIntro.vue";
import Paragraph from "../components/Paragraph.vue";
import Highlight from "../components/Highlight.vue";
import Quote from "../components/Quote.vue";
import NumberImage from "../components/NumberImage.vue";
import VideoPreview from "../components/VideoPreview.vue";
import VideoOverlay from "../components/VideoOverlay.vue";
import SliderImages from "../components/SliderImages.vue";
import BigNumber from "../components/BigNumber.vue";
import PointedList from "../components/PointedList.vue";
import Download from "../components/Download.vue";
import VizParagraph from "../components/VizParagraph.vue";
import VizRuota from "../components/VizRuota.vue";
import VizMosaico from "../components/VizMosaico.vue";
import InteractiveMap from "../components/InteractiveMap.vue";
import VizTimeline from "../components/VizTimeline.vue";

export default {
  name: "Chapter",
  data() {
    return {
      index: 0,
      progress: 0,
      offset: 0,
      activeSections: [],
      direction: ""
    };
  },
  computed: {
    chapterIndex() {
      return this.$route.params.chapterIndex;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.chapter.setAttribute("style", "opacity: 0");
      let hash = this.$route.hash;
      if (hash) {
        console.log(hash);
        setTimeout(() => {
          this.$scrollTo(hash, 0, { offset: -120 });
        }, 200);
      }
      setTimeout(() => {
        this.$refs.chapter.setAttribute("style", "opacity: 1");
      }, 200);
    });
  },
  components: {
    Scroller,
    Header,
    Footer,
    ChapterIntro,
    Paragraph,
    Highlight,
    Quote,
    NumberImage,
    VideoPreview,
    VideoOverlay,
    SliderImages,
    BigNumber,
    PointedList,
    Download,
    VizParagraph,
    VizRuota,
    VizMosaico,
    InteractiveMap,
    VizTimeline
  },
  methods: {
    isIncluded(array, value) {
      return array.indexOf(value) > -1;
    }
  }
};
</script>
<style lang="scss" scoped>
.tva-chapter {
  transition: opacity 0.1s ease;
}
</style>
